<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="gare-container">
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-5">
        <div class="cadremec">
          <audio controls>
            <source src="https://cdn.exploreve.fr/content/IM2/audio/MECANO.mp3" type="audio/mpeg" />
          </audio>
          <p>
            Si tu ne peux pas écouter,
            <a
              target="_blank"
              href="https://cdn.exploreve.fr/content/IM2/IM2 mécanienne (fichier pour les personnes malentendantes).pdf"
            >
              clique ici
            </a>
          </p>
          <div class="arrow-right"></div>
        </div>
        <div class="cadremec ber">
          <p v-if="!hasAll">
            Revenez me voir quand vous aurez tout ce qu’il faut, et je verrai ce que je peux faire.
          </p>
          <p v-else>
            Ah parfait, vous avez tout réuni. Faites voir ? ... ah oui, c'est l'injecteur qu’il faut adapter, pour votre
            Ballon-songe. Allons à la Tour Parachute, et je vous règle ça sur place.
          </p>
          <div class="arrow-right re"></div>
        </div>
      </div>
      <div class="col-md-1"></div>
      <div class="col-md-4">
        <img
          class="standardiste invert"
          src="https://cdn.exploreve.fr/content/cluedo/Mecanicienne.svg"
          height="400px"
        />
      </div>
    </div>
  </div>
</template>
<style>
.cadremec {
  font-family: "faune";
  top: 10px;
  left: 10px;
  position: absolute;
  background-color: white;
  width: 350px;
  height: auto;
  border-radius: 5px;
  text-align: left;
  padding: 10px 20px;
  padding-top: 30px;
  display: flex;
  flex-direction: column;
}

.ber {
  top: 180px;
}

.arrow-right {
  position: relative;
  content: "";
  top: -12px;
  left: 330px;
  width: 0px;
  height: 0px;
  border-left: 15px solid white;
  border-bottom: 15px solid transparent;
  border-top: 15px solid transparent;
}

.re {
  top: -30px;
}

.invert {
  transform: scaleX(-1);
}
</style>
<script>
export default {
  data: function () {
    return {};
  },
  props: {
    hasAll: Boolean
  },
  mounted() {
    if (this.hasAll) {
      this.$emit("hasSeen");
      this.$emit("audio", { action: "play-once", id: "musicvictoiremeca" });
    }
  }
};
</script>
